import React from "react";
import { HashRouter, BrowserRouter, Route, Switch } from "react-router-dom";

import { Login } from "../auth/Login";
import { Register } from "../auth/Register";
import { ForgotPassword } from "../auth/ForgotPassword";
import ProtectedRoute from "./ProtectedRoute";
import DashboardLayout from "../Dashboard/DashboardLayout";
import PaymentSuccess from "../Dashboard/Db/Explore/PaymentSuccess";
import PaymentFailed from "../Dashboard/Db/Explore/PaymentFailed";
import PrivacyPolicy from '../Dashboard/Db/PrivacyPolicy';
import OrderFailed from "../Dashboard/Db/Explore/OrderFailed";
import ActivateAccount from "../Dashboard/Db/ActivateAccount";
import Profile from "../Dashboard/Db/Profile/Profile";
export const Router = () => {
  return (
    <div>
      <HashRouter Router basename="">
        <Switch>
          <Route exact path={`/`} component={Login} />
          <Route exact path={`/register`} component={Register} />
          <Route exact path={`/forgotpassword`} component={ForgotPassword} />
          <Route exact path={`/payment-success`} component={PaymentSuccess} />
          <Route exact path={`/payment-failure`} component={PaymentFailed} />
          <Route exact path={`/payment-order-failure`} component={OrderFailed} />
          <Route exact path={`/privacy-policy`} component={PrivacyPolicy} />
          <Route exact path={`/activate`} component={ActivateAccount} />
          <ProtectedRoute path={`/dashboard`} component={DashboardLayout} />
          <Route component={Profile} />
        </Switch>
      </HashRouter >
    </div>
  );
};
